module.exports = __webpack_public_path__ + "img/toShop-banner.1dd2596d.png";